// An app's "connect to Plotweave" request opened while signed out is remembered here (for
// this tab), so the writer lands back on the consent page after signing in, signing up or
// finishing onboarding (ProtectedRoute sends them). Only the query string is kept; the
// path is always /oauth/authorize, so this can never send anyone elsewhere.
const KEY = 'plotweave.pendingAuthorize';
const MAX = 8000;

export const AUTHORIZE_PATH = '/oauth/authorize';

export function savePendingAuthorize(search: string): void {
  if (!search.startsWith('?') || search.length > MAX) return;
  try {
    sessionStorage.setItem(KEY, search);
  } catch {
    // Storage blocked: the app can start the connection again.
  }
}

export function pendingAuthorize(): string | null {
  try {
    const search = sessionStorage.getItem(KEY);
    return search && search.startsWith('?') && search.length <= MAX ? search : null;
  } catch {
    return null;
  }
}

export function clearPendingAuthorize(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
